import jsSHA from "jssha";
import { ICADModel } from "../interfaces";
import React from "react";

const getCADHash = (newProps: ICADModel | null) => {

    if (!newProps)
        return "";

    //Don't include uiSelections in the hash, as they can cause unnecessary image reloads which can 
    // lead to missing imageInfo in the session cache.
    let jsonString: string = JSON.stringify({ ...newProps, uiSelections:null }); 

    let objHash: any = new jsSHA("SHA-1", "TEXT");
    objHash.update(jsonString);
    return objHash.getHash("HEX") as string;
}


export default function useCADHash(props: ICADModel | null): string {

    const optionHash = React.useMemo(() => getCADHash(props), [props]);

    return optionHash;

}